export const _qs = 'querySelector';
export const _qsa = 'querySelectorAll';
export const _on = 'addEventListener';
export const _off = 'removeEventListener';
export const _html = 'innerHTML';
export const _text = 'textContent';
export const _class = 'classList';
export const _gattr = 'getAttribute';
export const _sattr = 'setAttribute';
export const _sattrNS = 'setAttributeNS';
export const _rattr = 'removeAttribute';
export const _data = 'dataset';
export const _cel = 'createElement';
export const _celNS = 'createElementNS';
export const _ctext = 'createTextNode';
